export enum eServices {
  title = 'title',
  escrow = 'escrow',
}
export const DisplayServices = {
  [eServices.title]: 'Title',
  [eServices.escrow]: 'Escrow',
};